import { createReducer } from '@reduxjs/toolkit';

import { loadMerchantDetailsSuccess, loadMerchantsListSuccess, loadMerchantsStart, resetMerchantDetails } from './actions';
import { IMerchantListData, IMerchantsReducer } from './types';

const initialState: IMerchantsReducer = {
  isLoading: false,
  isLoaded: false,
  data: {} as IMerchantListData,
  detailsLoaded: false,
  details: null,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(loadMerchantsStart, (state) => ({ ...state, isLoading: true }))
    .addCase(loadMerchantsListSuccess, (state, action) => ({ ...state, isLoading: false, isLoaded: true, data: action.payload }))
    .addCase(loadMerchantDetailsSuccess, (state, action) => ({
      ...state,
      isLoading: false,
      detailsLoaded: true,
      details: action.payload,
    }))
    .addCase(resetMerchantDetails, (state) => ({
      ...state,
      detailsLoaded: initialState.detailsLoaded,
      details: initialState.details,
    }));
});
